import {UiBaseIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "45",
  height: "59",
  viewBox: "0 0 45 59"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M42.837 25.066h-3.238a.831.831 0 0 1-.83-.83v-7.632C38.77 7.809 31.962.34 23.162.01 13.947-.321 6.309 7.063 6.309 16.272v8.048c0 .415-.332.83-.83.83H2.241A2.231 2.231 0 0 0 0 27.39v29.37A2.23 2.23 0 0 0 2.241 59h40.513a2.231 2.231 0 0 0 2.241-2.24V27.306c.083-1.244-.913-2.24-2.158-2.24zm-31.464-8.794c0-6.389 5.313-11.533 11.789-11.201 6.06.332 10.709 5.476 10.709 11.532v7.716c0 .415-.332.83-.83.83H12.12a.831.831 0 0 1-.831-.83v-8.047h.083z" }, null, -1)
  ])))
}
export default { render() { return h(UiBaseIcon, {icon: {render}, name: "lock-icon"}) } }